export enum ThemeAction {
  SET_THEME_LIGHT = 'SET_THEME_LIGHT',
  SET_THEME_DARK = 'SET_THEME_DARK',
  SET_THEME_DARK_COMPACT = 'SET_THEME_DARK_COMPACT',
  SET_THEME_LIGHT_COMPACT = 'SET_THEME_LIGHT_COMPACT'
}

export enum ThemeActionPayload {
  LIGHT_THEME = 'light',
  DARK_THEME = 'dark',
  LIGHT_COMPACT_THEME = 'light.compact',
  DARK_COMPACT_THEME = 'dark.compact'
}

const toggleTheme = (type: ThemeAction, payload: ThemeActionPayload) => () => ({
  type,
  payload
});

export const toggleThemeDark = toggleTheme(
  ThemeAction.SET_THEME_DARK,
  ThemeActionPayload.DARK_THEME
);
export const toggleThemeLight = toggleTheme(
  ThemeAction.SET_THEME_LIGHT,
  ThemeActionPayload.LIGHT_THEME
);
export const toggleThemeDarkCompact = toggleTheme(
  ThemeAction.SET_THEME_DARK_COMPACT,
  ThemeActionPayload.DARK_COMPACT_THEME
);
export const toggleThemeLightCompact = toggleTheme(
  ThemeAction.SET_THEME_LIGHT_COMPACT,
  ThemeActionPayload.LIGHT_COMPACT_THEME
);
